import {FC, ReactNode} from 'react';
import {twMerge} from 'tailwind-merge';

import Footer, {Props as FooterProps} from './Footer';
import Header, {Props as HeaderProps} from './Header';

interface Props {
    children: ReactNode;
    className?: string;
    footerProps?: FooterProps;
    headerProps?: HeaderProps;
    isResponsive?: boolean;
}

const PageLayout: FC<Props> = ({
    children,
    className = '',
    footerProps = {},
    headerProps = {},
    isResponsive = true,
}) => (
    <div
        className={twMerge(
            'min-h-screen absolute flex w-full flex-col bg-grey-100',
            isResponsive ? 'min-w-[22rem]' : 'min-w-[63.5rem]',
        )}
    >
        <div className="mb-8 flex min-h-0 flex-1 flex-col items-center">
            <div
                className={twMerge(
                    isResponsive && 'w-full max-w-sm sm:max-w-[37.5rem]',
                    className,
                )}
            >
                <Header {...headerProps} />
                {children}
            </div>
        </div>
        <Footer {...{isResponsive, ...footerProps}} />
    </div>
);

export default PageLayout;
